import { AuthAdapter as CoreAuthAdapter } from '@core/adapters';
import { AuthApiEndpoint } from '@infra/api-endpoint/auth.api.endpoint.ts';
import { UpdateIdPayload } from '@core/dto';

export class AuthAdapter extends CoreAuthAdapter {
  async updateId(payload: UpdateIdPayload): Promise<boolean | null> {
    const response = await this.http.patch<boolean | null>(
      AuthApiEndpoint.updateId,
      payload
    );
    return response.data;
  }
}
